import styled from "styled-components";

const RefundStyles = styled.section`
  position: relative;

  .refundContainer {
    width: calc(100% - 210px);
    margin-left: 210px;
    background: whitesmoke;
    min-height: 100vh;
    overflow-x: hidden;
    position: relative;
  }

  .refundContent {
    position: relative;
    background: #fff;
    min-height: 460px;
    border-radius: 8px;
    padding: 15px;
  }

  .refundContentWrapper {
    padding: 0 30px 30px 30px;
  }

  .refundsList {
    width: 100%;
    height: 100%;
  }

  .refundListHeader {
    display: flex;
    width: 100%;
    justify-content: space-around;
    height: 40px;
    color: #5d5d5d;
    font-size: 16px;
    font-weight: 600;
    border-top: 1px solid #f0f0f0;
    border-bottom: 1px solid #94abd1;

    .refundListHeaderName {
      width: 19%;
      padding: 12px;
      display: flex;
      align-items: center;
    }
    .refundListHeaderBenefit {
      width: 19%;
      padding: 12px;
      display: flex;
      align-items: center;
    }
    .refundListHeaderPrice {
      width: 14%;
      padding: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .refundListHeaderQuantity {
      width: 14%;
      display: flex;
      padding: 12px;
      align-items: center;
      justify-content: center;
    }
    .refundListHeaderStatus {
      width: 14%;
      padding: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .refundListHeaderDate {
      padding: 12px;
      display: flex;
      align-items: center;
      width: 19%;
      justify-content: center;
    }
    .refundListHeaderEmpty {
      width: 5%;
      padding: 12px;
    }
  }

  .refundsListItem {
    display: flex;
    height: 40px;
    font-size: 12px;
    font-weight: normal;
    max-height: 40px;
    cursor: pointer;
    background: white;

    &:hover {
      background: rgba(148, 171, 209, 0.3);
    }

    .refundsListItemName {
      width: 19%;
      display: flex;
      align-items: center;
      padding: 12px;
    }
    .refundsListItemBenefit {
      width: 19%;
      padding: 12px;
      display: flex;
      align-items: center;
    }
    .refundsListItemPrice {
      width: 14%;
      padding: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .refundsListItemQuantity {
      padding: 12px;
      display: flex;
      width: 14%;
      justify-content: center;
      align-items: center;
    }
    .refundsListItemStatus {
      display: flex;
      padding: 12px;
      width: 14%;
      justify-content: center;
      align-items: center;

      svg {
        width: 16px;
        height: 16px;
      }

      svg.pending {
        color: gray;
      }
      svg.accepted {
        color: green;
      }
      svg.rejected {
        color: red;
      }
    }
    .refundsListItemDate {
      display: flex;
      padding: 12px;
      width: 19%;
      justify-content: center;
      align-items: center;
    }

    .refundsListItemCheckbox {
      width: 5%;
      padding: 12px;
    }
  }

  .refundListSecondLayerActivityToggle {
    display: flex;
    gap: 20px;
  }

  .refundListSecondLayerActivity {
    margin: 10px 0 30px 0;
    display: flex;
    gap: 20px;
    justify-content: space-between;

    .checkboxCol {
      display: flex;
      gap: 5px;
    }

    .bulkAcceptOrDecline {
      color: #5d5d5d;
      font-size: 14px;
      cursor: pointer;

      .bulkAccept {
        color: #19cc95;
        font-size: 16px;
        font-weight: 600;
        text-decoration: underline;
      }

      .bulkDecline {
        color: #ed3f55;
        font-size: 16px;
        text-decoration: underline;
        font-weight: 600;
      }
    }
  }

  .refundListHeaderFilterWrapper {
    position: relative;
    display: flex;

    .refundListHeaderFilterWrapperFlex {
      display: flex;
      align-items: center;
    }

    .refundFilter {
      position: absolute;
      background: #ffffffff;
      border: 1px solid #1568bf;
      border-radius: 8px;
      padding: 12px;
      min-width: 150px;
      z-index: 10;

      .arrow {
        content: " ";
        position: absolute;
        bottom: 100%;
        left: 50%;
        margin-left: -9px;
        border-width: 10px;
        border-style: solid;
        border-color: transparent transparent #1568bf transparent;
      }
    }

    .refundFilterItem {
      cursor: pointer;
      padding: 5px;

      &:hover {
        background: rgba(148, 171, 209, 0.3);
      }
    }

    .refundFilterItemFlexCenter {
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      border-bottom: 1px solid #5d5d5d;
    }

    .refundFilterItemFlex {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 5px;
      font-weight: 500;

      svg {
        width: 20px;
        height: 20px;
      }

      svg.accepted {
        color: #19cc95;
      }

      svg.rejected {
        color: #ed3f55;
      }
    }

    button {
      background: transparent;
      border: none;
      padding: 9px;
      cursor: pointer;
    }

    svg {
      width: 14px;
      height: 14px;
    }
  }

  .refundsListItemTopName {
    display: flex;
    gap: 10px;
  }

  .refundsListItemBottomFlex {
    display: flex;
  }

  @media screen and (max-width: 576px) {
    .refundListHeader {
      display: none;
    }

    .refundsListItem {
      &:hover {
        background: transparent;
      }
    }
  }

  .refundFilterMobile {
    min-width: 120px !important;
  }

  .refundMobileHeader {
    display: flex;
    justify-content: space-around;
  }

  @media screen and (min-width: 577px) {
    .refundMobileHeader {
      display: none;
    }
  }

  // Todo reuse styles
  .employeesContainer {
    padding: 0 30px 30px 30px;
    display: flex;
    position: relative;
    background: #fff;
    min-height: 460px;
  }

  .firstMenu {
    display: flex;
    justify-content: space-between;
    padding: 16px;
    flex-wrap: wrap;
    background: #fff;
  }

  .buttonsWrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 50%;
    min-width: 450px;
  }

  .searchIcon {
    background: #f7f9fc;
    padding: 12px 0 8px 10px;
    border-radius: 8px 0 0 8px;
    margin-right: -10px;
    z-index: 2;
  }

  .filterButton {
    font-weight: 500;
    line-height: 16px;
  }

  .buttonsContainer {
    position: relative;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .filtersContainer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;

    .closeFiltersButton {
      display: none;
    }
    .selectsContainer {
      display: flex;
      gap: 15px;
      > div {
        width: 202px;
      }
    }
  }

  .addContainer {
    width: 24px;
    height: 24px;
    background: #fff;
    border-radius: 50%;
    color: #373737;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
  }

  .addSign {
    margin-right: 8px;
    font-size: 28px;
    line-height: 28px;
    font-weight: 400;
  }

  #employeesList {
    transition: all 0.4s ease-in-out;
    opacity: 0;
    width: 100%;
    background-color: whitesmoke;
  }

  .firstMenuMobile {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    display: none;
    background: #fff;
    padding: 8px 16px;

    .sortMobileButton {
      font-size: 16px;
      font-weight: 400;
    }
  }

  .secondMenu {
    width: 100%;
    padding: 8px 20px;
    background: #fff;

    .flexContainer {
      display: flex;
      align-items: center;
    }

    p {
      font-size: 14px;
      line-height: 16px;
      font-weight: 500;
      color: #1d1d1d;
    }

    .selected {
      width: 90px;
      color: ${props => props.selectedColor};
      margin: 0 11px;
    }
  }

  .tableHead {
    padding: 14px 30px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #94abd1;
    border-top: 1px solid #f0f0f0;
    background: #fff;
  }

  .tableBodyContainer {
    background: #f7f7f7;
    padding: 30px;
    margin: 20px 0 0 0;
    border-radius: 4px;
  }

  #addEmployeeForm {
    position: absolute;
    width: calc(100% - 60px);
    transform: translateX(110%);
    transition: all 0.4s ease-in-out;
    opacity: 0;
  }

  .buttonText {
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
  }

  .showAddEmployeeForm {
    transform: translateY(0) !important;
    opacity: 1 !important;
  }

  .hideEmployeeList {
    transform: translateX(-110%);
    opacity: 0;
    max-height: 1000px;
    overflow-y: auto;
  }

  .actionsDropdownWrapper {
    position: absolute;
    display: flex;
    flex-direction: column;
    width: 234px;
    right: 0;
    border-radius: 0px 4px 0px 0px;
    border: solid 1px transparent;
    z-index: 2;
    color: rgb(7, 6, 6);
    background-color: rgb(236, 236, 236);

    > span {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 8px 10px;
      cursor: pointer;
    }

    & span:first-child {
      display: none;
    }

    .buttonText {
      font-size: 14px;
      font-weight: 500;
      line-height: 16px;
    }
  }

  .actionsSortWrapper {
    position: absolute;
    display: flex;
    flex-direction: column;
    width: 234px;
    left: 0;
    border-radius: 0px 4px 0px 0px;
    border: solid 1px transparent;
    z-index: 2;
    background-color: rgb(236, 236, 236);

    .chevronContainer {
      width: 24px;
      height: 24px;
      background: #fff;
      border-radius: 50%;
      color: #373737;
      margin-right: 10px;

      svg {
        margin: 3px 0 0 7px;
      }
    }

    .sortButton {
      justify-content: flex-start;
    }

    .buttonText {
      font-size: 14px;
      font-weight: 500;
      line-height: 16px;
    }
  }

  .appliedFiltersContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
    background: #fff;

    .appliedFilters {
      display: flex;
      align-items: center;
      gap: 10px;
      overflow-x: auto;
      max-width: calc(100% - 80px);
      flex-wrap: wrap;

      .appliedFilterPill {
        display: flex;
        align-items: center;
        gap: 19px;
        background-color: #f0f4f9;
        color: #1d1d1d;
        padding: 6px 8px;
        border-radius: 23px;

        .removeFilter {
          cursor: pointer;
        }
      }
    }

    .clearButton {
      justify-content: flex-end;
      font-size: 12px;
      font-weight: 500;
      line-height: 16px;
    }
  }

  @keyframes showModal {
    from {
      transform: translateX(320px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  .filtersContainer.mobile {
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-end;
    width: 310px;
    padding: 90px 30px 30px 30px;
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
    background: rgb(255, 255, 255);
    border-radius: 4px;
    box-shadow: rgb(0 0 0 / 20%) 0px 2px 4px -1px,
      rgb(0 0 0 / 12%) 0px 1px 10px 0px, rgb(0 0 0 / 14%) 0px 4px 5px 0px;
    z-index: 10;
    animation: showModal 0.4s ease-in-out;
    transition: all 0.35s ease-in-out;
    transition-delay: 0.1s;
    > div {
      width: 100%;
    }
    .closeFiltersButton {
      display: unset;
      width: 40px;
      height: 40px;
      color: rgba(0, 0, 0, 0.54);
      border: none;
      outline: none;
      font-size: 20px;
      position: absolute;
      z-index: 2;
      right: 15px;
      top: 30px;
      font-weight: 500;
      cursor: pointer;
      background: rgba(255, 255, 255, 0.6);
      border-radius: 50%;
      &:hover {
        color: #1568bf;
        background: rgba(255, 255, 255, 0.8);
      }
    }
    .selectsContainer {
      flex-direction: column;
      width: 100%;
      > div {
        width: 100%;
      }
    }
  }

  .paginationWrapper {
    display: flex;
    justify-content: center;
    background: #fff;
    padding: 30px;
  }

  @media screen and (max-width: 1024px) {
    .buttonsWrapper {
      min-width: 400px;
    }
  }

  @media screen and (max-width: 960px) {
    .employeesContainer {
      padding: 0 15px 30px 15px;
    }

    .buttonsWrapper {
      min-width: 440px;
    }

    .addSign {
      margin: 0 4px;
    }

    .actionsDropdownWrapper {
      & span:first-child {
        display: flex;
      }
    }
  }

  @media screen and (max-width: 767px) {
    .refundContainer {
      width: 100%;
      margin: 0;
    }
  }
`;

export default RefundStyles;
